<template>
  <li class="duration-200">
    <div
      class="pl-4 py-2 flex space-x-2 items-center font-medium relative"
      :class="[
        level && `!pl-[${(level + 1) * 1.5}em]`,
        !products && 'opacity-50',
      ]"
    >
      <div class="flex items-center h-5" :class="!products && 'cursor-pointer'" @click="select">
        <input :disabled="!products" :checked="isActive" id="offers" aria-describedby="offers-description" name="offers" type="radio" class="focus:ring-primary h-4 w-4 text-primary border-gray-300 rounded-full">
      </div>
      <span v-if="!to">
        {{ name }}
      </span>
      <a v-else :href="to" target="_blank" class="hover:underline" :class="!products && 'cursor-auto'">
        {{ name }}
        <span v-if="products" class="text-gray-500 ml-1">({{ products }})</span>
      </a>
    </div>

    <div v-if="children && children.length" class="duration-200">
      <ul class="border-gray-100 border-t divide-y divide-gray-100" role="list">
        <category
          v-for="cat in children"
          :key="cat.id"

          :id="cat.id"
          :name="cat.name"
          :products="cat.products"
          :children="cat.children"
          :to="cat.to"

          :level="(level || 0) + 1"

          @select="targetId => $emit('select', targetId)"
        />
      </ul>
    </div>
  </li>
</template>

<script>

import { mapGetters } from "vuex"

export default {
  name: 'category',
  props: ['id', 'name', 'products', 'children', 'to', 'level'],
  methods: {
    select() {
      if (!this.products) return;
      this.$emit("select", this.id)
    },
  },
  computed: {
    ...mapGetters({
      context: 'editor/context',
    }),

    isActive() {
      return this.context && this.context.categoryId === this.id
    },
  },
}

</script>
